import React from 'react';
import { motion } from 'framer-motion';

interface LoadingSkeletonProps {
    count?: number;
    gridClassName?: string;
}

const LoadingSkeleton: React.FC<LoadingSkeletonProps> = ({ count = 6, gridClassName }) => {
    return (
        <div className={gridClassName || "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"}>
            {Array.from({ length: count }).map((_, index) => (
                <motion.div
                    key={index}
                    className="bg-white rounded-3xl shadow-soft overflow-hidden"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.3, delay: index * 0.1 }}
                >
                    {/* Image Skeleton */}
                    <div className="relative aspect-square bg-gray-200 animate-pulse">
                        <div className="absolute inset-0 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 animate-shimmer" />
                    </div>

                    {/* Content Skeleton */}
                    <div className="p-4 space-y-3">
                        {/* Category */}
                        <div className="h-3 bg-gray-200 rounded-full w-1/3 animate-pulse" />

                        {/* Title */}
                        <div className="space-y-2">
                            <div className="h-4 bg-gray-200 rounded-full w-full animate-pulse" />
                            <div className="h-4 bg-gray-200 rounded-full w-2/3 animate-pulse" />
                        </div>

                        {/* Price */}
                        <div className="pt-2">
                            <div className="h-6 bg-gray-200 rounded-full w-1/2 animate-pulse" />
                        </div>

                        {/* Buttons */}
                        <div className="grid grid-cols-2 gap-2 pt-2">
                            <div className="h-10 bg-gray-200 rounded-full animate-pulse" />
                            <div className="h-10 bg-gray-200 rounded-full animate-pulse" />
                        </div>
                    </div>
                </motion.div>
            ))}
        </div>
    );
};

export default LoadingSkeleton;
